import { Component, inject } from '@angular/core';
import { IncidentCategoryService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  IncidentCategoryCreateDto,
  IncidentCategoryDto,
  IncidentCategoryExcelDownloadDto,
  IncidentCategoryUpdateDto,
} from '../proxy/planning/dtos/incident-category';
import { INCIDENTCATEGORY_CONFIG, INCIDENTCATEGORY_FIELDS } from './incident-category.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-incident-category',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, IncidentCategoryService, ConfirmationService],
  templateUrl: './incident-category.html',
  styleUrl: './incident-category.scss',
})
export class IncidentCategory extends BaseCrudComponent<
  IncidentCategoryDto,
  IncidentCategoryCreateDto,
  IncidentCategoryUpdateDto,
  IncidentCategoryExcelDownloadDto
> {
  service = inject(IncidentCategoryService);
  config = INCIDENTCATEGORY_CONFIG;
  fields = INCIDENTCATEGORY_FIELDS;

  protected prepareUpdateDto(data: any, selected: IncidentCategoryDto): IncidentCategoryUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'IncidentCategory';
  }
}
